/* TwentySix search engine.
   Understands the way customers type in Hebrew: any form of a word (שמלה, שמלת, שמלות), with or without a leading
   ה/ו/ב/ל/ש, with ' or ׳, in Hebrew or English (שחורה, black), and small typos. What's in stock comes first,
   then whatever matches best, with a lift for new arrivals and best sellers.
   Data: templates/collection.ts-search-index.liquid. Used by assets/ts-search.js. */
(function (global) {
  'use strict';

  /* ---------- words ---------- */
  var FINALS = { 'ך': 'כ', 'ם': 'מ', 'ן': 'נ', 'ף': 'פ', 'ץ': 'צ' };
  var HEB = /[א-ת]/;
  function span(a, b) { return String.fromCharCode(a) + '-' + String.fromCharCode(b); }
  /* accents, Hebrew vowel points and cantillation marks; every kind of quote mark, ' and the geresh */
  var MARKS = new RegExp('[' + span(0x300, 0x36f) + span(0x591, 0x5bd) + span(0x5bf, 0x5c7) + ']', 'g');
  var QUOTES = new RegExp('[' + String.fromCharCode(0x22, 0x27, 0x60, 0xb4, 0x2018, 0x2019, 0x201c, 0x201d, 0x5f3, 0x5f4) + ']', 'g');
  var SUFFIXES = ['ות', 'ימ', 'ית', 'ה', 'ת', 'י'];  // endings as they look after norm() (no final letters)
  var LEADING = 'הובלמשכ';
  var STOP = {};

  function norm(s) {
    return String(s == null ? '' : s)
      .toLowerCase()
      .normalize('NFD')
      .replace(MARKS, '')
      .replace(QUOTES, '')
      .replace(/[ךםןףץ]/g, function (c) { return FINALS[c]; })
      .replace(/וו/g, 'ו')
      .replace(/יי/g, 'י')
      .replace(/(^|[^a-z])t[\s-]?shirts?(?![a-z])/g, '$1tshirt')
      .replace(/[^0-9a-zא-ת]+/g, ' ')
      .trim();
  }
  'של עם את על או גם מידה מידות size and the with for of in a an'.split(' ').forEach(function (w) { STOP[norm(w)] = 1; });

  function words(s) {
    var n = norm(s);
    return n ? n.split(' ') : [];
  }
  function stem(w) {
    if (HEB.test(w)) {
      for (var i = 0; i < SUFFIXES.length; i++) {
        var x = SUFFIXES[i];
        if (w.length - x.length >= 2 && w.slice(-x.length) === x) return w.slice(0, -x.length);
      }
      return w;
    }
    if (w.length > 4 && /(sses|shes|ches|xes)$/.test(w)) return w.slice(0, -2);
    if (w.length > 3 && /[^s]s$/.test(w)) return w.slice(0, -1);
    return w;
  }

  /* ---------- meanings: one idea, every way of writing it ----------
     [meaning, broader meaning, forms]. Multi-word forms use _ between the words. */
  var GROUPS = [
    ['dress', '', 'שמלה dress'],
    ['shirt', '', 'חולצה shirt tshirt טישרט טישירט tee blouse בלוזה'],
    ['basic', '', 'בייסיק basic'],
    ['buttoned', 'shirt', 'מכופתרת מכופתר מכפתרת buttoned'],
    ['polo', 'shirt', 'פולו polo'],
    ['sweat', 'shirt', 'פוטר סווטשירט סוטשירט סווצר סוצר הודי קפוצון hoodie sweatshirt'],
    ['tracksuit', 'sweat', 'טרנינג טרנינגים tracksuit'],
    ['pants', '', 'מכנס מכנסיים pants trousers'],
    ['jeans', '', 'גינס דנים jeans denim'],
    ['shorts', 'pants', 'שורט שורטס ברמודה מכנס_קצר shorts bermuda'],
    ['leggings', 'pants', 'טייץ טייטס leggings tights'],
    ['skirt', '', 'חצאית skirt'],
    ['jacket', '', 'גקט זקט בלייזר jacket blazer'],
    ['coat', '', 'מעיל טרנץ coat trench'],
    ['knit', '', 'סריג סוודר סרוג knit sweater jumper'],
    ['cardigan', 'knit', 'קרדיגן cardigan'],
    ['tank', '', 'גופיה גופייה גופית טופ אפודה tank top'],
    ['vest', '', 'וסט ווסט אפודה vest'],
    ['crop', '', 'קרופ crop'],
    ['body', '', 'בגד_גוף גוף body bodysuit'],
    ['corset', '', 'מחוך בסטייה corset bustier'],
    ['strapless', '', 'סטרפלס strapless'],
    ['jumpsuit', '', 'אוברול jumpsuit overall'],
    ['set', '', 'סט סטים חליפה חליפות set suit'],
    ['shoes', '', 'נעל נעליים shoes shoe sneakers סניקרס'],
    ['boots', 'shoes', 'מגף מגפיים מגפון boots boot'],
    ['sandals', 'shoes', 'סנדל סנדלים sandals'],
    ['flipflops', 'shoes', 'כפכף כפכפים flipflops slides'],
    ['heels', 'shoes', 'עקב עקבים heels'],
    ['flats', 'shoes', 'בובה בלרינה ballerina flats'],
    ['bag', '', 'תיק bag'],
    ['belt', '', 'חגורה belt'],
    ['hat', '', 'כובע hat cap קסקט'],
    ['earrings', '', 'עגיל עגילים earrings'],
    ['necklace', '', 'שרשרת necklace'],
    ['bracelet', '', 'צמיד bracelet'],
    ['sunglasses', '', 'משקפיים משקפי_שמש sunglasses'],
    ['scarf', '', 'צעיף מטפחת בנדנה scarf'],
    ['underwear', '', 'תחתונים חזייה underwear bra'],
    ['gift', '', 'גיפט_קארד כרטיס_מתנה גיפט מתנה שובר giftcard gift'],
    ['accessories', '', 'אקססוריז אקססוריס accessories'],
    ['black', '', 'שחור black'],
    ['white', '', 'לבן white'],
    ['cream', 'white', 'קרם שמנת אופוויט אוף_וויט cream offwhite'],
    ['beige', '', 'בז beige'],
    ['brown', '', 'חום brown'],
    ['camel', 'brown', 'קאמל camel'],
    ['mocca', 'brown', 'מוקה מוקא mocca mocha'],
    ['grey', '', 'אפור grey gray'],
    ['blue', '', 'כחול blue'],
    ['navy', 'blue', 'נייבי navy'],
    ['lightblue', 'blue', 'תכלת'],
    ['green', '', 'ירוק green'],
    ['olive', 'green', 'זית olive'],
    ['khaki', 'green', 'חאקי khaki'],
    ['taupe', 'green', 'טאופ taupe'],
    ['red', '', 'אדום red'],
    ['burgundy', 'red', 'בורדו burgundy'],
    ['pink', '', 'ורוד pink'],
    ['purple', '', 'סגול לילך purple lilac'],
    ['yellow', '', 'צהוב yellow'],
    ['orange', '', 'כתום orange'],
    ['gold', '', 'זהב זהוב gold'],
    ['silver', '', 'כסף כסוף silver'],
    ['leopard', '', 'מנומר נמר לאופרד leopard'],
    ['camo', '', 'הסוואה קאמו צבאי דגמח ארמי camo army'],
    ['zebra', '', 'זברה zebra'],
    ['plaid', '', 'משבצות משובץ משובצת checkered plaid'],
    ['polka', '', 'נקודות פולקה polka dots'],
    ['stripes', '', 'פסים מפוספס stripes striped'],
    ['dark', '', 'כהה כהים כהות dark'],
    ['light', '', 'בהיר light'],
    ['satin', '', 'סאטן satin'],
    ['chiffon', '', 'שיפון chiffon'],
    ['linen', '', 'פשתן linen'],
    ['leather', '', 'עור leather'],
    ['fur', '', 'פרווה fur'],
    ['velvet', '', 'קטיפה velvet'],
    ['lace', '', 'תחרה lace'],
    ['maxi', '', 'מקסי ארוך maxi long'],
    ['midi', '', 'מידי midi'],
    ['mini', '', 'מיני mini'],
    ['oversize', '', 'אוברסייז oversize oversized'],
    ['new', '', 'חדש new'],
    ['sale', '', 'סייל מבצע הנחה sale']
  ];
  var MEANS = {};    // word -> meanings
  var STEMS = {};    // stem -> meanings
  var PHRASES = [];  // [first word, second word, meaning], compared by stem so מכנסיים קצרים reads as מכנס קצר
  var PARENT = {};
  GROUPS.forEach(function (g) {
    if (g[1]) PARENT[g[0]] = g[1];
    g[2].split(' ').forEach(function (form) {
      if (form.indexOf('_') > -1) {
        var p = words(form.replace(/_/g, ' '));
        PHRASES.push([stem(p[0]), stem(p[1]), g[0]]);
        return;
      }
      var w = norm(form), st = stem(w);
      [[MEANS, w], [STEMS, st]].forEach(function (e) {
        var list = e[0][e[1]] || (e[0][e[1]] = []);
        if (list.indexOf(g[0]) < 0) list.push(g[0]);
      });
    });
  });
  function phrase(a, b) {
    a = stem(a); b = stem(b);
    for (var p = 0; p < PHRASES.length; p++) {
      if (PHRASES[p][0] === a && PHRASES[p][1] === b) return PHRASES[p][2];
    }
    return '';
  }
  /* meanings that name a kind of item, as opposed to a colour, fabric or cut */
  var KIND = {};
  ('dress shirt buttoned polo sweat pants jeans shorts leggings skirt jacket coat knit cardigan tank vest crop body corset ' +
   'strapless jumpsuit set shoes boots sandals flipflops heels flats bag belt hat earrings necklace bracelet sunglasses scarf ' +
   'underwear gift').split(' ').forEach(function (k) { KIND[k] = 1; });
  /* the word itself says it best (גוף is a body, גופיית a tank top, though both come down to גופ); a stem of two
     letters is too short to say anything (דני and דנים) */
  function meaningsOf(w, s) {
    return MEANS[w] || (w.length >= 3 && STEMS[w]) || (s.length >= 3 && (MEANS[s] || STEMS[s])) || [];
  }

  /* ---------- typos ---------- */
  function close(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return false;
    var prev2 = null, prev = [], cur, i, j;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur = [i];
      var best = i;
      for (j = 1; j <= lb; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (prev2 && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
        cur[j] = v;
        if (v < best) best = v;
      }
      if (best > max) return false;
      prev2 = prev;
      prev = cur;
    }
    return prev[lb] <= max;
  }

  /* ---------- the catalog ---------- */
  var W = { title: 10, colour: 8, type: 7, handle: 5, tag: 4, desc: 2 };
  var SKIP_TAG = /^(\d{1,2}\/\d{1,2}.*|online store|new|new arrivals|selling fast|צילומים.*|.*צילומים)$/;

  function Doc(row, rank, total, today) {
    var title = String(row[1] || '');
    var cut = title.indexOf('|');
    var base = cut > -1 ? title.slice(0, cut) : title;
    var tone = cut > -1 ? title.slice(cut + 1) : '';
    this.h = row[0];
    this.title = title;
    this.base = base.trim();
    this.type = String(row[2] || '').trim();
    this.avail = row[5] === 1 || row[5] === true;
    this.sale = row[6] === 1 || row[6] === true;
    this.age = Math.max(0, today - (row[7] || 0));
    this.pop = total > 1 ? 1 - rank / (total - 1) : 1;
    this.f = [];
    this.m = {};
    this.titleNorm = norm(base);
    this.add(words(base), W.title, true);
    /* a product sold per colour ("חולצת פייג' | שחורה") names its colour in the title, and its colour option only links
       the sister listings, so the title wins; otherwise the colour option says it, more strongly when there's one colour */
    var toneWords = words(tone), named = toneWords.some(function (w) { return meaningsOf(w, stem(w)).length; });
    var tones = String(row[4] || '').split('|').filter(Boolean);
    this.add(toneWords, W.colour);
    if (!named) this.add(words(tones.join(' ')), tones.length > 1 ? W.colour - 1.5 : W.colour);
    this.add(words(this.type), W.type);
    var self = this;
    String(row[3] || '').split('|').forEach(function (t) {
      t = t.trim().toLowerCase();
      if (t && !SKIP_TAG.test(t)) self.add(words(t), W.tag);
    });
    if (!HEB.test(this.h)) self.add(words(String(this.h).replace(/-/g, ' ')), W.handle);
    this.add(words(row[8]).slice(0, 30), W.desc);
    if (this.age <= 21) this.mean('new', W.tag);
    if (this.sale) this.mean('sale', W.tag);
  }
  Doc.prototype.add = function (list, weight, isTitle) {
    for (var i = 0; i < list.length; i++) {
      var w = list[i];
      if (!w || STOP[w] || /^\d+$/.test(w)) continue;
      var s = stem(w);
      var ms = meaningsOf(w, s);
      this.f.push({ w: w, s: s, wt: weight, first: isTitle && i === 0, m: ms });
      for (var k = 0; k < ms.length; k++) this.mean(ms[k], weight);
      if (i > 0) {
        var m = phrase(list[i - 1], w);
        if (m) this.mean(m, weight);
      }
    }
  };
  Doc.prototype.mean = function (m, weight) {
    if (!this.m[m] || this.m[m] < weight) this.m[m] = weight;
    var up = PARENT[m];
    if (up && (!this.m[up] || this.m[up] < weight * 0.45)) this.m[up] = weight * 0.45;
  };

  /* how well one typed word matches one product: [score, strong] */
  Doc.prototype.match = function (t) {
    var best = 0, strong = false, f = t.whole ? [] : this.f;
    for (var i = 0; i < f.length; i++) {
      var x = f[i], k = 0, sure = true;
      if (x.w === t.w) k = 1;
      else if (x.s === t.s && t.s.length >= 3) {
        /* same stem but two different things (גוף and גופיית) is not a match */
        k = t.m.length && x.m.length && !x.m.some(function (m) { return t.m.indexOf(m) > -1; }) ? 0 : 1;
      }
      else if (t.partial && t.w.length >= 2 && x.w.indexOf(t.w) === 0) {
        /* a word still being typed: מכנ is on its way to מכנס, but סט is already a word, so סטרפלס only comes after it */
        k = t.known ? 0.25 : 0.9;
        sure = !t.known;
      }
      else if (t.s.length >= 4 && x.w.indexOf(t.s) === 0) k = 0.85;
      else if (t.typo && (t.typo[x.w] || t.typo[x.s])) k = 0.85;
      if (!k) continue;
      var sc = (x.wt + (x.first ? 1.5 : 0)) * k * t.factor;
      if (sc > best) { best = sc; strong = sure && x.wt > W.desc; }
    }
    for (var k = 0; k < t.m.length; k++) {
      var mw = this.m[t.m[k]];
      if (mw) {
        var ms = mw * 0.95 * t.factor;
        if (ms > best) { best = ms; strong = mw > W.desc; }
      }
    }
    return [best, strong];
  };

  function term(w, partial) {
    var s = stem(w);
    return { w: w, s: s, partial: partial, m: meaningsOf(w, s), factor: 1, typo: null };
  }

  /* ---------- engine ---------- */
  function Engine(rows, opts) {
    opts = opts || {};
    var today = opts.today || Math.floor(Date.now() / 86400000);
    var docs = this.docs = [];
    for (var i = 0; i < rows.length; i++) docs.push(new Doc(rows[i], i, rows.length, today));
    var vocab = {}, spelled = {};
    docs.forEach(function (d) {
      d.f.forEach(function (x) { if (x.wt > W.desc && x.w.length >= 3) vocab[x.w] = (vocab[x.w] || 0) + 1; });
      /* each word as the catalog writes it (חום, ג'קט), for "showing results for" */
      (d.base + ' ' + d.type).split(/\s+/).forEach(function (raw) {
        raw = raw.replace(/[|(),.:;!?]/g, '');
        var n = norm(raw);
        if (n && n.indexOf(' ') < 0 && !spelled[n]) spelled[n] = raw;
      });
    });
    this.known = vocab;
    this.spelled = spelled;
    /* words a typo can be read as: the catalog's own, and every way of naming a kind of item or a colour */
    this.vocab = Object.keys(vocab);
    var self = this;
    Object.keys(MEANS).forEach(function (k) { if (k.length >= 3 && !vocab[k]) self.vocab.push(k); });
    this.collections = (opts.collections || []).map(function (c) {
      return { t: c.t, u: c.u, w: words(c.t).map(function (x) { return { w: x, s: stem(x), m: meaningsOf(x, stem(x)) }; }) };
    });
  }

  /* a typed word that is already a whole word of the catalog (or names something) */
  Engine.prototype.term = function (w, partial) {
    var t = term(w, partial);
    t.known = t.m.length > 0 || !!this.known[w];
    if (partial && !t.m.length && w.length >= 3) t.m = ahead(w);
    return t;
  };
  /* a word still being typed takes the meaning of the words it is on its way to (סווד → סוודר) */
  var AHEAD = {};
  function ahead(w) {
    if (AHEAD[w]) return AHEAD[w];
    var out = [];
    Object.keys(MEANS).forEach(function (k) {
      if (k.length > w.length && k.indexOf(w) === 0) MEANS[k].forEach(function (m) { if (out.indexOf(m) < 0) out.push(m); });
    });
    return (AHEAD[w] = out);
  }

  Engine.prototype.terms = function (q, typing) {
    var raw = String(q || '');
    var partialLast = !!typing && !/\s$/.test(raw);
    var list = words(raw).filter(function (w) { return !STOP[w]; });
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var meaning = i + 1 < list.length ? phrase(list[i], list[i + 1]) : '';
      if (meaning) {
        /* two words that name one thing (בגד גוף, מכנס קצר) are matched as that thing */
        out.push({ w: list[i] + ' ' + list[i + 1], s: '', partial: false, m: [meaning], factor: 1, typo: null, whole: true });
        i++;
      } else {
        out.push(this.term(list[i], partialLast && i === list.length - 1));
      }
    }
    return out;
  };

  /* a word nothing matches gets a second reading: without a leading ה/ו/ב/ל/מ/ש/כ, then as a small typo */
  Engine.prototype.rescue = function (t) {
    var docs = this.docs, i;
    if (t.whole) return t;
    /* strong: a match in the title, type, colour, tags or name (not only somewhere in a description) */
    function any(x, strong) {
      for (i = 0; i < docs.length; i++) {
        var r = docs[i].match(x);
        if (strong ? r[1] : r[0]) return true;
      }
      return false;
    }
    if (any(t, true)) return t;
    var forms = [t.w];
    if (HEB.test(t.w) && t.w.length >= 4 && LEADING.indexOf(t.w[0]) > -1) {
      var cut = t.w.length >= 5 && LEADING.indexOf(t.w[1]) > -1 && t.w[1] !== t.w[0] ? [t.w.slice(1), t.w.slice(2)] : [t.w.slice(1)];
      for (var c = 0; c < cut.length; c++) {
        var alt = this.term(cut[c], t.partial);
        alt.factor = 0.9;
        if (any(alt, true)) return alt;
        forms.push(cut[c]);
      }
    }
    /* a word found only in descriptions (מקסי) is still a real word: it stays as typed */
    if (any(t, false)) return t;
    if (t.w.length >= 4) {
      var hits = [];
      for (i = 0; i < this.vocab.length; i++) {
        var v = this.vocab[i];
        for (var f = 0; f < forms.length; f++) {
          var w = forms[f], n = w.length, max = n >= 7 ? 2 : 1;
          /* two slips are forgiven in a word of five or more that starts right (חציות for חצאית) */
          if (n >= 5 && max < 2 && v.length >= n - 1 && v.length <= n + 1 && v.slice(0, 2) === w.slice(0, 2)) max = 2;
          /* still typing a longer word: its start counts too, with or without a letter she skipped (from five letters,
             so a short name like ג'ואי is not read as the start of something else) */
          if (close(w, v, max) || (t.partial && n >= 5 && v.length > n && (close(w, v.slice(0, n), max) || close(w, v.slice(0, n + 1), max)))) { hits.push(v); break; }
        }
      }
      if (hits.length) {
        /* the closest words of the catalog stand in for it, as if she had typed them (חולצא reads as חולצה) */
        var known = this.known, fixed = this.term(t.w, false), best = hits[0];
        fixed.typo = {};
        fixed.m = [];
        fixed.factor = 0.95;
        hits.forEach(function (h) {
          var hs = stem(h);
          fixed.typo[h] = 1;
          if (hs.length >= 3) fixed.typo[hs] = 1;
          meaningsOf(h, hs).forEach(function (m) { if (fixed.m.indexOf(m) < 0) fixed.m.push(m); });
          /* shown back to her: a word that names something first, then the most common one */
          if (!!MEANS[h] !== !!MEANS[best] ? !!MEANS[h] : known[h] > known[best]) best = h;
        });
        fixed.fixed = this.spelled[best] || best;
        if (any(fixed, false)) return fixed;
      }
    }
    return t;
  };

  Engine.prototype.search = function (q, opts) {
    opts = opts || {};
    var terms = this.terms(q, opts.typing);
    var out = { q: q, total: 0, list: [], docs: [], suggestions: [], collections: [], fixed: '' };
    if (!terms.length) return out;
    var self = this;
    terms = terms.map(function (t) { return self.rescue(t); });
    /* what she typed, with the corrected words in place */
    var fixes = {};
    terms.forEach(function (t) { if (t.typo) fixes[t.w] = t.fixed; });
    out.fixed = Object.keys(fixes).length ? String(q).trim().split(/\s+/).map(function (raw) { return fixes[norm(raw)] || raw; }).join(' ') : '';

    var n = terms.length, found = [], docs = this.docs, N = docs.length, i, k;
    var typed = n > 1 ? terms.map(function (t) { return t.w; }).join(' ') : '';
    var kinds = terms.map(function (t) { return t.m.some(function (m) { return KIND[m]; }); });

    /* first pass: who matches what, and how common each word is */
    var rows = [], df = terms.map(function () { return 0; });
    for (i = 0; i < N; i++) {
      var row = null;
      for (k = 0; k < n; k++) {
        var r = docs[i].match(terms[k]);
        if (r[0]) { (row || (row = []))[k] = r; df[k]++; }
      }
      if (row) rows.push([docs[i], row]);
    }
    /* rarer words say more (a product name over a colour) */
    var idf = df.map(function (c) { return 1 + 0.5 * Math.log((N + 1) / (c + 1)); });
    var key = -1;
    for (k = 0; k < n; k++) {
      var modifier = terms[k].m.length && terms[k].m.every(function (m) { return m === 'dark' || m === 'light'; });
      if (df[k] && !modifier && (key < 0 || df[k] < df[key])) key = k;
    }

    for (i = 0; i < rows.length; i++) {
      var d = rows[i][0], hits = rows[i][1], score = 0, hit = 0, strong = 0, kindMiss = false;
      for (k = 0; k < n; k++) {
        if (hits[k]) { hit++; score += hits[k][0] * idf[k]; if (hits[k][1]) strong++; }
        else if (kinds[k]) kindMiss = true;
      }
      /* a near miss still has to be the kind of item asked for and share the most telling word:
         "תיק שחור" may add other bags, "מרבל כחול" other colours of מרבל, never just other black or blue things */
      if (hit < n - 1 || (hit < n && (kindMiss || strong < hit || (key > -1 && !hits[key])))) continue;
      var tier = hit === n ? (strong === n ? 0 : 1) : 2;
      if (typed && d.titleNorm.indexOf(typed) > -1) score += 4;
      /* new arrivals and best sellers get a small lift: enough to lead among close matches, not to beat a clearly better one */
      score *= 1 + 0.15 * Math.exp(-d.age / 45) + 0.1 * d.pop;
      found.push({ d: d, tier: tier, score: score });
    }

    var strongCount = 0, fullCount = 0;
    found.forEach(function (x) { if (x.tier === 0) strongCount++; if (x.tier < 2) fullCount++; });
    found = found.filter(function (x) {
      /* matches found only in a description fill in when there are hardly any real ones */
      if (x.tier === 1) return strongCount < 4;
      if (x.tier === 2) return fullCount < 6;
      return true;
    });
    /* in stock first; a weak match that's in stock still comes before a sold-out one; close matches last, in stock first too */
    function band(x) { return x.tier === 2 ? (x.d.avail ? 4 : 5) : (x.d.avail ? 0 : 2) + x.tier; }
    found.sort(function (a, b) { return band(a) - band(b) || b.score - a.score || b.d.pop - a.d.pop; });

    out.total = found.length;
    out.exact = found.filter(function (x) { return x.tier < 2; }).length;
    out.list = found.map(function (x) { return x.d.h; });
    out.docs = found.map(function (x) { return x.d; });
    if (opts.typing) out.suggestions = this.suggest(terms, found);
    out.collections = this.matchCollections(terms);
    return out;
  };

  /* phrases worth tapping: product types first, then product names */
  Engine.prototype.suggest = function (terms, found) {
    var seen = {}, list = [], qn = terms.map(function (t) { return t.w; }).join(' ');
    function push(text, weight) {
      var k = norm(text);
      if (!k || k === qn) return;
      if (!seen[k]) { seen[k] = { text: text, weight: 0 }; list.push(seen[k]); }
      seen[k].weight += weight;
    }
    found.slice(0, 40).forEach(function (x) {
      if (x.tier !== 0) return;
      var d = x.d, typeHit = d.type && terms.every(function (t) {
        return words(d.type).some(function (w) { return w.indexOf(t.w) === 0 || stem(w) === t.s || (t.s.length >= 3 && w.indexOf(t.s) === 0); });
      });
      if (typeHit) push(d.type, 3);
      if (d.base) push(d.base, 1 + x.score / 40);
    });
    list.sort(function (a, b) { return b.weight - a.weight; });
    return list.slice(0, 4).map(function (s) { return s.text; });
  };

  Engine.prototype.matchCollections = function (terms) {
    var out = [];
    this.collections.forEach(function (c) {
      var ok = terms.every(function (t) {
        return c.w.some(function (x) {
          return x.w === t.w || x.s === t.s || (t.partial && x.w.indexOf(t.w) === 0) || (t.s.length >= 3 && x.w.indexOf(t.s) === 0) ||
            t.m.some(function (m) { return x.m.indexOf(m) > -1; });
        });
      });
      if (ok && !out.some(function (o) { return o.u === c.u; })) out.push({ t: c.t, u: c.u });
    });
    return out.slice(0, 3);
  };

  var api = {
    create: function (rows, opts) { return new Engine(rows, opts); },
    norm: norm,
    words: words,
    stem: stem
  };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else global.TSSearchEngine = api;
})(this);
